import { AttendanceDto } from './attendanceDto.types';
import { DepartmentDto } from './department.types';
import { LeaveDto, LeaveLimits } from './leaves.types';
import { Salary } from './salary.types';
import { Store } from './shop.types';
import { RolesEnum } from './route.types';

export interface UserPermissions {
  permissions: PermissionType[];
}

export enum PermissionType {
  CONTROL_PANEL_USER = "control_panel_user",
  CONTROL_PANEL_ADMIN = "control_panel_admin",
  VIEW_USERS = "view_users",
  EDIT_USERS = "edit_users",
  VIEW_DEPARTMENTS = "view_departments",
  EDIT_DEPARTMENTS = "edit_departments",
  VIEW_BRANCHES = "view_branches",
  EDIT_BRANCHES = "edit_branches",
  EXPORT = "export",
  VIEW_REPORTS = "view_reports",
  MANAGE_SHIFTS = "manage_shifts",
  LEAVE_REQUEST = "leave_request",
  VIEW_LEAVE = "view_leave",
  EDIT_LEAVE = "edit_leave",
  OVERTIME = "overtime",
  FIELD_MODE_REQUESTS = "field_mode_requests",
  CREATE_NOTIFICATIONS = "create_notifications",
  VIEW_SALARIES = "view_salaries",
  CHECK_IN_OUT = "check_in_out",
  BREAK = "break",
  COMPANY = "company_settings",
  FILE_UPLOAD = "file_upload",
  FILE_VIEW = "file_view",
  VIEW_TICKETS_ADMIN = "view_tickets_admin",
  VIEW_TICKETS_USER = "view_tickets_user",
  EDIT_TICKETS = "edit_tickets",
  PRICING_ONLY = "pricing_only",
  PRICING_ACCESS = "pricing_only",
  VIEW_ASSETS = "view_assets",
  VIEW_COMPANY_PAYMENT= "view_company_payment",
  VIEW_COMPANY_TIMESHEET= "view_company_timesheet",
  VIEW_MEALS= "view_meals",
  MANAGE_COMPANY = "manage_company",
  MANAGE_LEAVE_HIERARCHY = "manage_leave_hierarchy",
  MANAGE_REFERRAL_CAMPAIGNS = "manage_referral_campaigns",
  
  // === SAHA YÖNETİMİ PERMISSIONS ===
  VIEW_FIELD_ACTIVITIES = "view_field_activities",
  // CREATE_FIELD_ACTIVITY = "create_field_activity",
  // EDIT_FIELD_ACTIVITY = "edit_field_activity",
  // DELETE_FIELD_ACTIVITY = "delete_field_activity",
  VIEW_VEHICLES = "view_vehicles",
  // MANAGE_VEHICLES = "manage_vehicles",
  
  // === SÜPER ADMİN PERMISSIONS ===
  // Dashboard ve Genel Erişim
  SUPER_ADMIN_DASHBOARD = "super_admin_dashboard",
  
  // Şirket Yönetimi
  SUPER_ADMIN_VIEW_COMPANIES = "super_admin_view_companies",
  SUPER_ADMIN_CREATE_COMPANY = "super_admin_create_company", 
  SUPER_ADMIN_EDIT_COMPANY = "super_admin_edit_company",
  SUPER_ADMIN_DELETE_COMPANY = "super_admin_delete_company",
  SUPER_ADMIN_IMPERSONATE = "super_admin_impersonate",
  
  // Finansal Yönetim
  SUPER_ADMIN_VIEW_FINANCIALS = "super_admin_view_financials",
  SUPER_ADMIN_MANAGE_PAYMENTS = "super_admin_manage_payments",
  SUPER_ADMIN_VIEW_INVOICES = "super_admin_view_invoices",
  SUPER_ADMIN_MANAGE_SUBSCRIPTIONS = "super_admin_manage_subscriptions",
  
  // İçerik ve Pazarlama Yönetimi
  SUPER_ADMIN_MANAGE_COUPONS = "super_admin_manage_coupons",
  SUPER_ADMIN_MANAGE_PRODUCTS = "super_admin_manage_products",
  SUPER_ADMIN_MANAGE_REFERRAL_CAMPAIGNS = "super_admin_manage_referral_campaigns",
  SUPER_ADMIN_BROADCAST = "super_admin_broadcast",
  
  // Sistem Yönetimi
  SUPER_ADMIN_USER_MANAGEMENT = "super_admin_user_management",
  SUPER_ADMIN_SYSTEM_SETTINGS = "super_admin_system_settings",
  SUPER_ADMIN_VIEW_ANALYTICS = "super_admin_view_analytics",
  
  // Eski permission'lar (geriye dönük uyumluluk için)
  SUPER_ADMIN_BUSSINESS = "super_admin_bussiness", // deprecated - SUPER_ADMIN_VIEW_ANALYTICS kullanın
}




export enum UserStatus {
  ACTIVE = "active",
  RESIGNED = "resigned",
  DELETED = "deleted"
}

export enum BloodType {
  A_POSITIVE = "A+",
  A_NEGATIVE = "A-",
  B_POSITIVE = "B+",
  B_NEGATIVE = "B-",
  AB_POSITIVE = "AB+",
  AB_NEGATIVE = "AB-",
  O_POSITIVE = "O+",
  O_NEGATIVE = "O-",
  UNKNOWN = "Bilinmiyor"
}

export interface ForgottenCheckoutDto {
  recordId: number; // veya string, API'nize bağlı
  entryTime: string;
  exitTime?: string | null; // Opsiyonel veya null olabilir
  user?: { // Kullanıcı bilgileri API'den geliyorsa
    id: number;
    firstName?: string;
    lastName?: string;
    profilePicture?: string;
    gender?: "male" | "female" | "other";
    department?: { name?: string };
    branch?: { name?: string };
  };
}

export interface ForgottenCheckinDto {
  id: number;
  firstName: string;
  lastName: string;
  title: string;
  profilePicture?: string;
  department: { name?: string }[];
  branch: { name?: string }[];
  shiftStart: string;
  gender?: "male" | "female" | "other";
}

// Temel kullanıcı bilgileri için interface
export interface BaseUserInfo {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  title?: string;
  phone?: string;
  emergencyContact?: string;
  hireDate: Date;
  terminationDate?: Date | null;
  birthDate?: Date;
  permissions?: PermissionType[];
  primaryDepartment: DepartmentDto;
  maritalStatus?: "single" | "married";
  educationLevel?: 'primary' | 'secondary' | 'bachelor' | 'master' | 'phd';
  gender?: "male" | "female" | "other";
  address?: string;
  city?: string;
  nationalId?: string;
  salaries?: Salary[];
  status: UserStatus;
  companyId?: number;
  annualLeaveLimit?: number;
  remainingAnnualLeaveLimit?: number;
  isFixedShift?: boolean;
  isFaceIdAllow?: boolean;
  bloodType?: BloodType;
  chronicDiseases?: string[];
}

// Diğer ilişkili varlıklar için interfaces
// interface Shift {
//   id: number;
//   name: string;
//   startTime: string;
//   endTime: string;
//   flexTime: number;
//   createdAt: string;
//   updatedAt: string;
// }

// interface Company {
//   id: number;
//   name: string;
//   address: string;
//   phone: string;
//   email: string;
//   taxNumber: string;
//   taxOffice: string;
//   settings: any | null;
//   createdAt: string;
//   updatedAt: string;
// }

// interface Permissions {
//   id: number;
//   name: string;
//   description: string;
//   permissions: {
//     create: boolean;
//     read: boolean;
//     update: boolean;
//     delete: boolean;
//   };
//   createdAt: string;
//   updatedAt: string;
// }

// Ana User interface'i
export interface User extends BaseUserInfo {
  id: number;
  workDuration: number;
  department?: DepartmentDto[];
  // shift: Shift;
  profilePicture: string;
  // company: Company;
  branch?: Store[];
  avatar?: string;
  employeeType?: EmploymentType;
  //permissions: Permissions;
  createdAt: string;
  attendance?: AttendanceDto[];
  leaves?: LeaveDto[];
  updatedAt: string;
  leaveLimits?: LeaveLimits;
  assignedVehicles?: any[];
  deviceId?: string | null;
  isInFieldMode?: boolean;
  fieldModeAutoApprove?: boolean;
}

// Mevcut enumları ekleyelim
export enum EmploymentType {
  OFFICE = 'office',
  FIELD = 'field',
  HYBRID = 'hybrid'
}




// BaseUserInfo'yu kategorilere ayıralım
export interface PersonalInfo {
  firstName: string;
  lastName: string;
  birthDate?: Date;
  nationalId: string;
  gender: "male" | "female" | "other";
  maritalStatus: "single" | "married";
  educationLevel: 'primary' | 'secondary' | 'bachelor' | 'master' | 'phd';
  photo?: string;
  bloodType?: BloodType;
  chronicDiseases?: string[];
}

export interface ContactInfo {
  city: string;
  email: string;
  phone: string;
  emergencyContact?: string;
}

export interface WorkInfo {
  departmentId?: number[];
  branchId?: number[];
  hireDate: Date;
  terminationDate?: Date | null;
  annualLeaveLimit?: number;
  remainingAnnualLeaveLimit?: number;
  isFixedShift?: boolean;
  employeeType?: EmploymentType;
}

export interface SecurityInfo {
  password: string;
  role: RolesEnum;
  title: string;
}

// UserCreateDTO'yu güncelle
export interface UserCreateDTO {
  email: string;
  firstName: string;
  lastName: string;
  role: RolesEnum;
  companyId: number;
  password?: string;
  department?: number | null;
  branch?: number | null;
  title?: string;
  phone?: string;
  emergencyContact?: string;
  hireDate?: Date;
  birthDate?: Date;
  maritalStatus?: 'single' | 'married';
  educationLevel?: 'primary' | 'secondary' | 'bachelor' | 'master' | 'phd';
  gender?: 'male' | 'female' | 'other';
  city?: string;
  nationalId?: string;
  annualLeaveLimit?: number;
  initialRemainingLeave?: number;
  isFixedShift?: boolean;
  permissions?: string[];
  workDuration?: number;
  profilePicture?: string;
  primaryDepartment?: number | null;
  status?: 'active' | 'inactive' | 'suspended';
  severity?: 'low' | 'medium' | 'high';
  ipControl?: boolean;
  employeeType?: EmploymentType;
}

export interface UpdateUserBySuperAdminDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  title?: string;
  role?: 'admin' | 'manager' | 'user';
  status?: 'active' | 'resigned' | 'deleted';
  phone?: string;
  emergencyContact?: string;
  birthDate?: string | Date;
  maritalStatus?: 'single' | 'married';
  educationLevel?: 'primary' | 'secondary' | 'bachelor' | 'master' | 'phd';
  gender?: 'male' | 'female' | 'other';
  address?: string;
  city?: string;
  district?: string;
  nationalId?: string;
  annualLeaveLimit?: number;
  isFixedShift?: boolean;
  departmentIds?: number[];
  branchIds?: number[];
  password?: string;
  primaryDepartmentId?: number;
  employeeType?: EmploymentType;
}

export interface UserUpdateDTO extends Omit<Partial<UserCreateDTO>, 'companyId' | 'password'> {
  // Bu DTO, temel kullanıcı güncelleme işlemleri için kullanılır.
  // Süper adminin yapacağı özel güncellemeler için UpdateUserBySuperAdminDto kullanılır.
  bloodType?: BloodType;
  chronicDiseases?: string[];
}

export interface UserBirthdaysResponseDto {
  today: BirthdayUserDto[];
  thisWeek: BirthdayUserDto[];
  thisMonth: BirthdayUserDto[];
}

export interface BirthdayUserDto {
  userId: number;
  name: string;
  birthDate: string;
  gender: string;
  profilePicture: string;
  department?: DepartmentDto[];
  branch?: Store[];
}

export interface YearlyDetailsForEmployeeResponseDto {
  workDays: number;
  lateDays: number;
  leaveDays: number;
  absentDays: number;
}

export interface YearlyWorkStatsResponseDto {
  todayWorkHours: string;
  requiredShiftHours: string;
  requiredWeeklyHours: string;
  requiredMonthlyHours: string;
  todayVsWeekChange: string;
  totalWeekHours: string;
  weekChange: string;
  totalMonthHours: string;
  monthChange: string;
}

export interface WorkScheduleResponseDto {
  workIntervals: {
    start: string;
    end: string;
  }[];
  breakIntervals: {
    start: string;
    end: string;
  }[];
  overtimeIntervals: {
    start: string;
    end: string;
  }[];
}

export interface EligibleApprover {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
}

